export default __webpack_public_path__ + "static/media/pgmico(5).d2c649ef.png";